import { resetPasswordConfirm } from "../actions/passwordResetActions";
import { createSlice } from "@reduxjs/toolkit";

export interface passwordState {
  processed: boolean;
  loading: boolean;
  error: boolean;
  errorMessage?: string;
  errorDetails?: any;
}

const initialState: passwordState = {
  processed: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
};

const resetPasswordConfirmSlice = createSlice({
  name: "resetPasswordConfirm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetPasswordConfirm.pending, (state) => {
        state.processed = false;
        state.loading = true;
        state.error = false;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(resetPasswordConfirm.fulfilled, (state) => {
        state.processed = true;
        state.loading = false;
      })
      .addCase(resetPasswordConfirm.rejected, (state, action) => {
        state.loading = false;

        if (action.payload) {
          state.error = action.payload.error;
          state.errorMessage = action.payload.message;
          state.errorDetails = action.payload.details;
        } else {
          state.error = true;
          state.errorMessage = undefined;
          state.errorDetails = undefined;
        }
      });
  },
});

export default resetPasswordConfirmSlice.reducer;
